import { render, staticRenderFns } from "./purchaseList.vue?vue&type=template&id=4feb6b2a&"
import script from "./purchaseList.vue?vue&type=script&lang=js&"
export * from "./purchaseList.vue?vue&type=script&lang=js&"
import style0 from "./purchaseList.vue?vue&type=style&index=0&id=4feb6b2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports